var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createPortal } from 'react-dom';
import { useState, useRef } from 'react';
import { useIsomorphicLayoutEffect } from '../hooks';
var DEFAULT_ID = 'waffles-portal-root';
function Portal(_a) {
    var _b = _a.id, id = _b === void 0 ? DEFAULT_ID : _b, children = _a.children;
    var portalRef = useRef(null);
    var _c = __read(useState(false), 2), isMounted = _c[0], setIsMounted = _c[1];
    var _d = __read(useState(Object.create(null)), 2), forceUpdate = _d[1];
    useIsomorphicLayoutEffect(function () {
        var rootNode = document.getElementById(id);
        if (rootNode) {
            portalRef.current = rootNode;
        }
        else {
            portalRef.current = document.createElement('div');
            portalRef.current.id = id;
        }
        if (!document.body.contains(portalRef.current)) {
            document.body.appendChild(portalRef.current);
            forceUpdate(Object.create(null));
        }
        setIsMounted(true);
    }, [id]);
    return isMounted && portalRef.current
        ? createPortal(children, portalRef.current)
        : null;
}
export default Portal;
